import ReactDOM from "react-dom";
import Backbone from "pages/common/lib/backbone-helpers";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";

import {
    syncStoreAndCollection,
    BackwardsCompatibleFilesCollection
} from "pages/common/lib/upload";

import UploaderStore from "pages/common/state/store/uploader/uploader";

import Uploader from "./default/default";
import ProfilePicUploader from "./profile-picture/profile-picture";
import CompactUploader from "./compact/compact";

import { render } from "util/react-utils";

const UploaderView = Backbone.View.extend({
    initialize: function ({
        footerText = ``,
        type,
        viewType = `default`,
        previewUrl,
        context,
        defaultPreviewOptions,
        footerTooltipText,
        width,
        height
    }) {
        this.collection = new BackwardsCompatibleFilesCollection([]);
        this.store = UploaderStore.create({
            context,
            organizationId: App.Models.organization.id
        });

        this.footerText = footerText;
        this.viewType = viewType;
        this.type = type;
        this.previewUrl = previewUrl;
        this.defaultPreviewOptions = defaultPreviewOptions;
        this.footerTooltipText = footerTooltipText;
        this.overrideDimensions = { width, height };

        this.dispose = syncStoreAndCollection(this.store, this.collection);
    },

    setAspectRatio: () => {},

    render: function () {
        if (this.viewType === `default`) {
            render(
                <DndProvider backend={HTML5Backend}>
                    <Uploader
                        footerText={this.footerText}
                        uploaderStore={this.store}
                        defaultPreviewOptions={this.defaultPreviewOptions}
                        width={this.overrideDimensions.width}
                        height={this.overrideDimensions.height}
                    />
                </DndProvider>,
                this.el
            );
        } else if (this.viewType === `profile`) {
            render(
                <ProfilePicUploader
                    uploaderStore={this.store}
                    profileUrl={this.previewUrl}
                />,
                this.el
            );
        } else if (this.viewType === `compact`) {
            render(
                <DndProvider backend={HTML5Backend}>
                    <CompactUploader
                        footerText={this.footerText}
                        uploaderStore={this.store}
                        defaultPreviewOptions={this.defaultPreviewOptions}
                        footerTooltipText={this.footerTooltipText}
                        displayErrorMsg={false}
                    />
                </DndProvider>,
                this.el
            );
        }
        return this;
    },

    clean: function () {
        ReactDOM.unmountComponentAtNode(this.el);
        this.dispose();
    },

    destroyView: function () {
        this.clean();
    },

    destroy: function () {
        this.clean();
        UploaderView.__super__.destroy.call(this);
    }
});

export default UploaderView;
